import React, { useEffect, useState } from "react";
import s from "./detailGANSAL.module.css";

//services
import masiveDistributionServices from "../../../../../api/delivery/masiveDistribution";

//assets
import { currencyFormat } from "../../../../../helpers/currency";
import Pager from "../../../../Shared/Pagination/Pagination";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

//materialUi
import {
  Alert,
  CircularProgress,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Snackbar,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BallotIcon from "@mui/icons-material/Ballot";

const DetailGANSAL = ({ detail, setDetail }) => {
  const { textColor } = useSelector((state) => state.local);
  const { formatCurrency } = currencyFormat();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [openError, setOpenError] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageCustom, setPageCustom] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getDetailData = () => {
    setLoading(true);
    masiveDistributionServices
      .getGansalDetail(page, pageSize, detail?.data?.id)
      .then((res) => {
        setItems(res?.items?.content);
        setCategories(res?.categories);
        setTotalPages(res?.items?.totalPages);
        setLoading(false);
      })
      .catch(() => {
        setOpenError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    getDetailData();
  }, [page, pageSize]);

  return (
    <Grid container className={s.container}>
      <Grid item container xs={11} className={s.header}>
        <Grid item xs={1} lg={1}>
          <ArrowBackIcon
            sx={{ fontSize: "2rem", color: "primary.main", mr: 1 }}
            onClick={() => {
              setLoading(false);
              setDetail({ status: false, data: {} });
            }}
            className={s.arrow}
          />
        </Grid>
        <Grid item xs={11} lg={11} className={s.titleContainer}>
          <BallotIcon sx={{ fontSize: "2rem", color: "primary.main", mr: 1 }} />
          <h4>{`${t("drawDetail")}: ${detail.data.emission}`}</h4>
        </Grid>
      </Grid>

      <Grid item xs={11} className={s.data}>
        {loading ? (
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <CircularProgress size="3rem" />
          </Grid>
        ) : items?.length ? (
          <TableContainer className={s.tableContainer}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{ backgroundColor: "primary.main", color: textColor }}
                  >
                    {t("coupon")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ backgroundColor: "primary.main", color: textColor }}
                  >
                    {t("value")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ backgroundColor: "primary.main", color: textColor }}
                  >
                    {t("quantity")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ backgroundColor: "primary.main", color: textColor }}
                  >
                    {t("percentage")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((detail, i) => {
                  // let category = categories.find(category => category.categoryId === detail.categoryId);
                  return (
                    <React.Fragment key={i}>
                      <TableRow>
                        <TableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {detail?.couponNumber}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {formatCurrency(detail?.category?.value)}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          {detail?.category?.totalPrizes}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          % {detail?.category.commissionPercentage}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              fontSize: "1.5rem",
              fontWeight: 300,
            }}
          >
            {t("noResults")}
          </Grid>
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Pager
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageCustom={pageCustom}
          setPageCustom={setPageCustom}
        />
      </Grid>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default DetailGANSAL;
